<template>

  <a target="_blank" :href="item.pdf">
    <pdf ref="pdf" :src="item.pdf" :resize="true" :text="false">
      <template slot="loading">
      </template>
    </pdf>
    <pdf ref="pdf" :src="item.pdf" :resize="true" :text="false" :page="2"></pdf>
  </a>

</template>

<script>
  import pdf from 'pdfvuer'

  export default {
    name: 'Contact',
    components: {
      pdf
    },
    data() {
      return {
        item: {
          pdf: "https://www.asspm.fr/rubriques/contacts_commissions.pdf"
        }
      }
    }
  }

</script>